export const offer_front_text = [
  {
    url: "zaburzenia-nerwicowe",
    title: "Zaburzenia nerwicowe",
    text: [
      "Nerwice są najpowszechniej  występującymi  zaburzeniami natury psychicznej. Przejawiają się w bardzo zróżnicowanych  formach takich jak zaburzenia zachowania (czynności natrętne), zaburzenia procesów psychicznych (myśli obsesyjne), zaburzeń emocji oraz zaburzeń funkcjonowania ciała.",
      "Nerwice bardzo często występują  w formie zwanej zespołem lęku uogólnionego, którego cechą charakterystyczną jest to, że lęk  towarzyszy  człowiekowi przez większość czasu, niezależnie od sytuacji. Inne przejawy nerwicy to zaburzenia depresyjne, zaburzenia pourazowe,  hipochondrie, bóle psychogenne i wiele innych.",
    ],
    message: [
      "Jeśli doświadczasz któregoś z tych objawów, lub objawów zbliżonych, umów się na spotkanie konsultacyjne!",
    ],
  },
  {
    url: "zaburzenia-dlugotrwaly-stres",
    title: "Zaburzenia związane z długotrwałym stresem",
    text: [
      "Długotrwały stres związany z codziennym życiem bardzo negatywnie wpływa na nasze samopoczucie. Jest przyczyną wielu nerwic i dolegliwości somatycznych. Rozchwianie emocjonalne  związane z długotrwałym stresem utrudnia nam koncentrację, komplikuje relacje z  innymi ludźmi, zaburza spokój i komfort wewnętrzny. Często   powoduje przygnębienie  i smutek.",
    ],
    message: [
      "Jeśli  z jakichś powodów  odczuwasz  stres i  zaczynasz  doświadczać zaburzeń z nim związanych, nie zostawaj sam z problemem. On się sam nie rozwiąże! Umów się na spotkanie konsultacyjne i pozwól sobie pomóc!",
    ],
  },
  {
    url: "traumy-przypadki-losowe",
    title: "Traumy związane z przypadkami losowymi",
    text: [
      "Życie bywa bardzo trudne. Doświadcza nas takimi  zdarzeniami jak choroba – własna lub bliskiej osoby – śmierć,  rozwód, utrata pracy.  I wieloma jeszcze innymi, nie mniej stresującymi,  zdarzeniami losowymi.  Stres związany z takimi sytuacjami jest ogromny, a konsekwencje psychiczne  bardzo poważne.  Czujemy się bezradni, zagubieni, nie wiemy jak postępować. Często z rozpaczy popełniamy błędy o fatalnych skutkach.",
    ],
    message: [
      "Jeśli znalazłeś się w takiej sytuacji  skontaktuj się z nami.  Zadbamy o twoją równowagę psychiczną i pomożemy przetrwać ten trudny czas.",
    ],
  },
  {
    url: "kryzys-w-zyciu-osobistym-i-zawodowym",
    title: "Kryzysy w życiu osobistym i zawodowym",
    text: [
      "Kryzys osobisty lub zawodowy zakłóca naszą wewnętrzną równowagę emocjonalną i wywołuje  wiele negatywnych emocji.  W sytuacji kryzysu poziom stresu jest tak wysoki, że  przekracza możliwości obronne danej osoby  i w dużym stopniu zaburza jej normalne, codzienne funkcjonowanie.  Wywołuje  panikę, odczuwamy szok i chaos, mamy poczucie, że jesteśmy totalnie zagubieni i nie panujemy nad tym, co się nam przytrafia.",
      "Kryzys osobisty może  mieć bardzo silny wpływ na człowieka, szczególnie jeśli ten jest pozostawiony „sam sobie”, a negatywne emocje, których doświadcza są zbyt silne, by je mógł pokonać.  W takich sytuacjach możliwe jest, że kryzys pozostawi głęboki ślad w psychice  w postaci lęku, czy utraty równowagi emocjonalnej.",
    ],
    message: [
      "Ponieważ najbardziej charakterystyczną cechą kryzysu jest niemożność samodzielnego poradzenia sobie z zaistniałą sytuacją, zapraszamy do kontaktu. Razem potrafimy zażegnać każdy kryzys!",
    ],
  },
  {
    url: "zaburzenia-osobowosci",
    title: "Zaburzenia osobowości",
    text: [
      "Zaburzenia osobowości to cały zbiór zaburzeń psychicznych, który skutkuje ukształtowaniem u danej osoby nieprawidłowych, utrudniających normalne funkcjonowanie w społeczeństwie, cech osobowości. Zaburzenia osobowości możemy więc  określić jako trwałe wzorce niefunkcjonalnego postępowania człowieka w jego środowisku społecznym i zawodowym.",
      "Zaburzenia osobowości przejawiają się zazwyczaj jako  negatywne nastawienie do świata  i ludzi, wycofanie z relacji społecznych i aktywności zawodowych lub też jako nadmierna chęć kierowania innymi i dominacji.  Ludziom o zaburzonej osobowości brakuje  elastyczności i umiejętności dostosowania się  do grupy, co powoduje  problemy w życiu zawodowym i osobistym.",
    ],
    message: [
      "Jeśli czujesz, że doświadczasz problemów podobnych do opisanych powyżej, nie wahaj się  i umów na spotkanie konsultacyjne z naszymi specjalistami. Warto skorzystać z pomocy!",
    ],
  },
  {
    url: "terapia-grupowa",
    title: "Terapia grupowa",
    text: [
      "Terapia grupowa jest interesującą alternatywą dla terapii indywidualnej. Może także stanowić ciekawe jej uzupełnienie. Polega ona na regularnych spotkaniach tych samych osób (w CT Empatia preferujemy grupy zamknięte), które we współpracy z terapeutą prowadzącym grupę, dyskutują na ważne dla nich tematy. Osoby te wspólnie rozwijają się przechodząc przez kolejne etapy leczenia.",
    ],
    textAlt: [
      {
        title: "Dla kogo?",
        text: "Terapia grupowa jest zalecana jako skuteczna metoda leczenia w szerokim spektrum trudności i zaburzeń. Mogą z niej skorzystać osoby mające trudności w relacjach interpersonalnych, znajdujące się w traumach, doświadczające obniżenia nastroju, ale także zaburzeń osobowości. Terapia grupowa może również być bardzo skutecznym sposobem leczenia różnorodnych fobii społecznych.",
      },
      {
        title: "Korzyści wynikające z terapii grupowej",
        text: "Praca w grupie uruchamia szereg mechanizmów sprzyjających leczeniu i rozwojowi. Podczas terapii grupowej u pacjentów tworzy się poczucie przynależności pozytywnie oddziałujące na komfort uczestników i dające im poczucia bezpieczeństwa, zaufania i akceptacji. Dzięki temu pacjenci mają większą łatwość w komunikowaniu swoich przeżyć i emocji. Interakcje pomiędzy pacjentami, a także pomiędzy pacjentami i terapeutami, są dzięki temu szczere i bezpośrednie, co sprzyja leczeniu i rozwojowi. Informacje zwrotne uzyskiwane od innych pacjentów są cennymi wskazówkami ułatwiającymi pokonywanie różnorodnych problemów.",
      },
      {
        title: "Wielkość grupy terapeutycznej",
        text: "Optymalna wielkość grupy terapeutycznej to od 6 do 8 osób. Liczebność taka umożliwia optymalne uruchomienie wszelkich procesów grupowych sprzyjających skutecznemu leczeniu.",
      },
      {
        title: "Czas trwania terapii grupowej i częstotliwość spotkań",
        text: "Terapia grupowa w CT Empatia trwa minimum 3 miesiące przy założeniu 2 spotkań w tygodniu. Czas trwania 1 sesji wynosi 90 minut.",
      },
      {
        title: "Cena uczestnictwa",
        text: "Koszt jednej sesji terapii grupowej wynosi 50,00 PLN",
      },
    ],
    message: [],
  },
];
